// src/polyfill.js
(function () {
  if (typeof window === 'undefined') return;

  const origResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class ResizeObserver extends origResizeObserver {
    constructor(callback) {
      super(entries => {
        window.requestAnimationFrame(() => {
          try {
            callback(entries);
          } catch (e) {
            console.warn('ResizeObserver error suppressed:', e);
          }
        });
      });
    }
  };
})();